import React from 'react';
import { AppBar, Box, IconButton, Skeleton, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import UserNavbar from './UserNavbar';
import { useMe } from '@/features/auth';
import { formatDuration } from '@/shared/lib/utils';

type NavbarProps = {
    sidebarWidth: number;
    toggler: () => void;
};

const Header: React.FC<NavbarProps> = ({ sidebarWidth, toggler }) => {
    const { data: meResponse, isLoading: loading, error: userError } = useMe();
    const userData = meResponse?.data?.success ? meResponse.data.data : null;

    return (
        <>
            <AppBar
                position="fixed"
                className="shadow-subtle border-b border-border-subtle"
                sx={{
                    backgroundColor: 'var(--color-surface)',
                    width: { md: `calc(100% - ${sidebarWidth}px)` },
                    ml: { md: `${sidebarWidth}px` },
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
            >
                <Toolbar
                    className="justify-between text-black md:justify-end"
                    sx={{
                        minHeight: { xs: '56px', sm: '64px' },
                        px: { xs: 2, sm: 3 },
                    }}
                >
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={toggler}
                        sx={{
                            mr: 2,
                            display: { md: 'none' },
                            color: 'var(--color-text-gray)',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    {loading ? (
                        <Box className="flex items-center gap-x-3 mr-4">
                            <Skeleton variant="rounded" width={100} height={40} />
                        </Box>
                    ) : userData?.plan ? (
                        <div className="hidden md:flex items-center px-2 py-1 gap-1 rounded-md border border-text-light text-sm">
                            <span className="text-secondary">{userData?.plan?.name}</span>/
                            <span className="text-primary">{userData?.plan?.expired_time ? formatDuration(Date().toString(), userData?.plan?.expired_time) : 'No expiration'}</span>
                        </div>
                    ) : (
                        <div className="hidden md:flex items-center px-2 py-1 gap-1 rounded-md border border-text-light text-sm">
                            <span className="text-primary">Your plan expired</span>
                        </div>
                    )}
                    <UserNavbar />
                </Toolbar>
            </AppBar>
        </>
    );
};

export default Header;
